import axios, { AxiosResponse } from "axios";
import { apiUrlBase } from "../../data/urls";
import returnAuthHeaderForAJAX from "../auth/returnAuthHeaderForAJAX";

type GetAnalyticsDataAsync = (payload: {
  accessToken: string;
  data: {
    domain: string;
    type: string;
  };
}) => Promise<AxiosResponse<any>>;

export const getAnalyticsDataAsync: GetAnalyticsDataAsync = ({
  accessToken,
  data,
}) => {
  return new Promise((resolve, reject) => {
    const apiUrl = `${apiUrlBase}/api/v1/websites/get_analytics_data`;

    axios
      .post(apiUrl, data, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
